/* CONNECTION */
export const CONNECT_CHAT = "CONNECT_CHAT"
export const CONNECT_CHAT_SUCCESS = "CONNECT_CHAT_SUCCESS"
export const CONNECT_CHAT_FAIL = "CONNECT_CHAT_FAIL"
export const DISCONNECT_CHAT = "DISCONNECT_CHAT"

/* USERS */
export const FETCH_ONLINE_USERS = "FETCH_ONLINE_USERS"
export const SET_ONLINE_USERS = "SET_ONLINE_USERS"

/* MESSAGES */
export const FETCH_MESSAGES = "FETCH_MESSAGES"
export const FETCH_MESSAGES_SUCCESS = "FETCH_MESSAGES_SUCCESS"
export const FETCH_MESSAGES_FAIL = "FETCH_MESSAGES_FAIL"

export const SEND_MESSAGE = "SEND_MESSAGE"
export const SEND_MESSAGE_SUCCESS = "SEND_MESSAGE_SUCCESS"
export const SEND_MESSAGE_FAIL = "SEND_MESSAGE_FAIL"

export const RECEIVE_MESSAGE = "RECEIVE_MESSAGE"
export const MARK_MESSAGES_READ = "MARK_MESSAGES_READ"

/* CONVERSATIONS */
export const SET_ACTIVE_CONVERSATION = "SET_ACTIVE_CONVERSATION"
export const CLEAR_ACTIVE_CONVERSATION = "CLEAR_ACTIVE_CONVERSATION"

/* NOTIFICATIONS */
export const FETCH_NOTIFICATIONS = "FETCH_NOTIFICATIONS"
export const FETCH_NOTIFICATIONS_SUCCESS = "FETCH_NOTIFICATIONS_SUCCESS"
export const FETCH_NOTIFICATIONS_FAIL = "FETCH_NOTIFICATIONS_FAIL"

export const RECEIVE_NOTIFICATION = "RECEIVE_NOTIFICATION"
export const MARK_NOTIFICATION_READ = "MARK_NOTIFICATION_READ"
export const MARK_ALL_NOTIFICATIONS_READ = "MARK_ALL_NOTIFICATIONS_READ"

/* UI STATE */
export const TOGGLE_CHAT_PANEL = "TOGGLE_CHAT_PANEL"
export const SET_CHAT_PANEL_OPEN = "SET_CHAT_PANEL_OPEN"
